
  import { Vue, Component, Prop } from "vue-property-decorator";

  import CardBodyItem from "@/components/card/CardBodyItem.vue";
  import SearchableDocumentsListCustom from "@/components/documents/SearchableDocumentsListResources.vue";
  import UploadDocumentResources from "@/components/documents/UploadDocumentResources.vue";
  import { User } from "@/generated/graphql";

  @Component({
    components: {
      CardBodyItem,
      SearchableDocumentsListCustom,
      UploadDocumentResources,
    },
  })
  export default class Documents extends Vue {
    @Prop({ type: String, required: true }) readonly contractorUserId!: string;
    @Prop({ type: String, required: true }) readonly contractorFullName!: string;
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;

    processing: boolean = false;

    get query(): Object {
      return {
        _and: [
          {
            uploaded_by: {
              _eq: this.currentUser.id,
            },
          },
          {
            attached_to: {
              user_id: {
                _eq: this.contractorUserId,
              },
            },
          },
        ],
      };
    }
  }
